import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ShieldCheck } from "lucide-react";

const COOKIE_KEY = "lw_cookie_consent";

function updateGtagConsent(granted) {
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: granted ? "granted" : "denied",
      ad_storage: granted ? "granted" : "denied",
      ad_user_data: granted ? "granted" : "denied",
      ad_personalization: granted ? "granted" : "denied",
    });
  }
}

export default function CookieBanner({ onOpenDatenschutz }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    updateGtagConsent(true);
    setVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem(COOKIE_KEY, "essential");
    updateGtagConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] animate-fade-in-up"
    >
      <div className="bg-white border-t border-slate-200 shadow-[0_-8px_30px_rgba(0,0,0,0.1)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex items-start gap-3 flex-1">
              <div className="h-10 w-10 bg-cyan-50 rounded-xl flex items-center justify-center shrink-0 mt-0.5">
                <ShieldCheck className="h-5 w-5 text-cyan-700" />
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-800 mb-1">
                  Diese Website verwendet Cookies
                </p>
                <p className="text-sm text-slate-500 leading-relaxed">
                  Wir nutzen Cookies und Google Analytics, um unsere Website zu verbessern und Ihnen die bestmögliche Erfahrung zu bieten.
                  Bei Zustimmung werden anonymisierte Nutzungsdaten erfasst.{" "}
                  <button
                    onClick={onOpenDatenschutz}
                    className="text-cyan-700 hover:underline font-medium"
                    data-testid="cookie-datenschutz-link"
                  >
                    Mehr erfahren
                  </button>
                </p>
              </div>
            </div>

            <div className="flex items-center gap-3 shrink-0 w-full md:w-auto">
              <Button
                data-testid="cookie-accept-essential-btn"
                onClick={acceptEssential}
                variant="outline"
                className="flex-1 md:flex-none border-slate-200 text-slate-600 hover:bg-slate-50 rounded-xl px-5 h-10 text-sm font-medium"
              >
                Nur notwendige
              </Button>
              <Button
                data-testid="cookie-accept-all-btn"
                onClick={accept}
                className="flex-1 md:flex-none bg-cyan-700 hover:bg-cyan-600 text-white rounded-xl px-5 h-10 text-sm font-semibold shadow-sm"
              >
                Alle akzeptieren
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
